import { httpRequest } from "../../http";
import { MetricType } from "@models/fieldMap.model";
export class CommandListMetricTypes {
  async run(): Promise<MetricType[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/metric-types/`;
    return httpRequest<MetricType[]>(url, { method: "GET" });
  }
}
